<template>
    <div>
        <div v-if="emptyBO">
            <div class="empty-wrap pt-4">
                <h2 class="text-[#080056] text-[16px] font-bold text-center mb-4">Tell us about the beneficial owners.
                    Beneficial owners are individuals with significant control or ownership of the business (owners,
                    director or shareholder)</h2>
                <p class="text-[#080056] text-[16px] font-normal text-center mb-4">You may add one or more owners,
                    directors,
                    or shareholders as long as the owner(s) collectively own at least 51% equity in the business.</p>
                <div class="flex justify-center items-center"><button @click="addNewBO"
                        class="text-[16px] font-bold  py-2 px-2 ">Add Beneficial Owner(s)</button></div>
            </div>
        </div>
        <div v-if="addNew">
            <div class="tabs flex  pt-8 mb-2 gap-6">
                <button class="flex-1 flex items-center " v-for="(tab, index) in tabs" :key="index" :class="{
                    active: selectedIndex === index || completedSteps.includes(index)
                }" @click="selectTab(index)">
                    <h1>{{ tab.count }}</h1>

                    <span>{{ tab.name }}</span>
                    <img :src="tab.widget" alt="" srcset="">
                </button>
            </div>
            <!-- <hr /> -->
            <div class="tab-content mt-4">
                <component :is="selectedComponent" :selectedReuploadTab='selectedReuploadTab'
                    @openIdentity="openIdentity" :ownerData="ownerData" @openAddress="openAddress"
                    @saveAddress="saveAddress"></component>
            </div>
        </div>
    </div>
</template>

<script>

import ArrowLine from '../../../../../../../../../public/icons/line nav.svg';
import PersonalData from './modules/bs/pa/PersonalData.vue';
import Identity from './modules/bs/pa/id.vue';
import Address from './modules/bs/pa/Address.vue';



export default {
    components: {
        PersonalData,
        Identity,
        Address,
    },
    data() {
        return {
            emptyBO: true,
            addNew: false,
            orgimage: '',
            companyName: '',
            organizationId: '',
            user: {},
            location: {},
            selectedIndex: 0,
            completedSteps: [],
            ownerData: {},
            identityData: {},
            addressData: {},
            tabs: [
                { count: 1, widget: ArrowLine, name: 'Personal Data', component: PersonalData },
                { count: 2, widget: ArrowLine, name: 'Identity', component: Identity },
                { count: 3, name: 'Address', component: Address },
            ],
        };
    },
    props: ['selectedReuploadTab'],
    mounted() {
        this.findUserDetails();
    },

    computed: {

        payload() {
            return {
                orgId: this.organizationId,
                beneficialOwners: [
                    {
                        name: this.ownerData.fullName,
                        email: this.ownerData.email,
                        phoneNumber: this.ownerData.mobile_no,
                        country: this.ownerData.country,
                        role: this.ownerData.selected,
                        equity:this.ownerData.equity,

                        identity: {
                            type: this.identityData.selectedDoc,
                            number: this.identityData.identity,
                            documentUrl: this.identityData.document
                        },

                        address: {
                            country: this.addressData.country,
                            state: this.addressData.state,
                            city: this.addressData.city,
                            zipCode: this.addressData.zipCode,
                            apartmentNumber: this.addressData.apartmentNumber,
                            address: this.addressData.address
                        },

                        proofOfAddress: {
                            type: this.addressData.verify,
                            documentUrl: this.addressData.imageUrl
                        }
                    },


                ]
            }
        },

        selectedComponent() {
            return this.tabs[this.selectedIndex].component;
        },

    },



    methods: {
        async findUserDetails() {
            try {
                let response = await this.$_findUserDetails();
                this.location = response.data.data.Org.locations[0];
                this.organizationId = response.data.data.Org.id;
                this.companyName = response.data.data.Org.companyname;
                this.orgimage = response.data.data.Org.orgimage;

            } catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },
        addNewBO() {
            this.addNew = true;
            this.emptyBO = false;

        },
        openIdentity(kycData) {
            this.ownerData = kycData; // Store the received data in a local variable
            this.selectedIndex = 1;
        },

        openAddress(IdData) {
            this.identityData = IdData; // Store the received data in a local variable            
            if (IdData) {
                // this.completedSteps.push(1); // step 2 completed
                if (!this.completedSteps.includes(1)) {
                    this.completedSteps.push(1);
                }
                this.selectedIndex = 2;
            }
        },

        saveAddress(imageUrl) {
            this.addressData = imageUrl; // Store the received data in a local variable
            this.updateKyc();
        },

        async updateKyc() {
            try {
                let response = await this.$_saveBusinessKycInformation(this.payload);

                if (response.data.success === true) {
                    const kyc = response?.data?.data?.org?.companyKYC;
                    if (kyc) {
                        this.$store.dispatch("saveBusinessDetails", kyc);
                    }
                    this.generateToast("Your information has been updated!", "success");
                    this.$router.push({ name: "AccountProfile" });
                }
            } catch (error) {
                this.handleError(error);
                this.updatingUser = false;
            }
        },
        
    },

};
</script>

<style scoped>
.empty-wrap {
    max-width: 700px;
    margin: 0 auto;
}

.empty-wrap>div>button {
    background-color: #FCC210;
    border-radius: 100px;
    color: #10233E;
}

.tabs>:nth-child(1),
.tabs>:nth-child(2) {
    justify-content: space-between;
}

.tabs>:nth-child(1)>h1 {
    font-size: 12px;
    font-weight: 700;
    padding: 3% 4% 3% 4%;
    border-radius: 50%;
    background-color: #10233E;
    color: white;
}

.tabs>:nth-child(1)>span {
    font-weight: 600;
    font-weight: 14px;
    color: #14171F;
}

.tabs>:nth-child(3) {
    gap: 17%;
}

.tabs>:nth-child(2)>span,
.tabs>:nth-child(3)>span {
    font-weight: 600;
    font-weight: 14px;
    color: #7A90A7;
}

.tabs>:nth-child(2)>h1,
.tabs>:nth-child(3)>h1 {
    font-size: 12px;
    font-weight: 700;
    padding: 2% 3% 2% 3%;
    border-radius: 50%;
    background-color: #EBF2FA;
    color: #667499;
}

.tabs .active>span {
    font-weight: 600;
    font-weight: 14px;
    color: #14171F;
}

.tabs .active>h1 {
    font-size: 12px;
    font-weight: 700;
    padding: 3% 4% 3% 4%;
    border-radius: 50%;
    background-color: #10233E;
    color: white;
}
</style>